import React from 'react';
import ErrorFallback from 'components/error-fallback';
import { ErrorBoundary } from 'react-error-boundary';
import { Box, Grid, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { PEPVIGIL } from 'pages/dlops-dashboard/utils/constant';
import { Item, style } from '../style';
import EditExisitingProject from './editExistingProject';
import breadcrumbIcon from '../../../assets/images/dlopsImages/arrow_forward.svg';

const EditProject = () => {
    const history = useHistory();
    const handleNavigation = () => {
        history.push('/pepvigil-projects');
        localStorage.removeItem('create_project');
    };
    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            {' '}
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h5">
                        <Item sx={style.subHeader}>
                            <div
                                style={{
                                    // marginLeft: '28px',
                                    marginTop: '8px',
                                    fontSize: '14px',
                                    textAlign: 'left',
                                }}
                                className="contentContainer"
                            >
                                <span>{PEPVIGIL}</span>
                                <img src={breadcrumbIcon} alt=" bredcrumb" style={style.breadcrumbIcon} />
                                <span aria-hidden="true" style={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={() => handleNavigation()}>
                                    Projects
                                </span>
                                <img src={breadcrumbIcon} alt=" bredcrumb" style={style.breadcrumbIcon} />
                                <span style={{ fontWeight: 'bold', color: '#005CBC' }}>Edit Project</span>
                            </div>
                        </Item>
                    </Typography>
                </Grid>
            </Grid>
            <Box className="contentContainer">
                <Box
                    sx={{
                        top: '164px',
                        // left: '27px',
                        // width: '1500px',
                        height: '70px',
                        background: '#FFFFFF 0% 0% no-repeat padding-box',
                        borderRadius: '4px',
                        opacity: 1,
                        marginTop: '20px',
                        padding: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        // marginLeft: '100px',
                    }}
                >
                    <Typography data-testid="edit-project-heading" sx={{ fontSize: '18px', fontWeight: '700', color: '#0047BA' }}>
                        Edit Project
                    </Typography>
                </Box>
                <EditExisitingProject />
            </Box>
        </ErrorBoundary>
    );
};

export default EditProject;
